import { ACTIONS_MASTER } from '../actions/master';

export default (state = {}, action) => {
    switch (action.type) {
        case ACTIONS_MASTER.GET_YEAR_SUCCESS:
        case ACTIONS_MASTER.GET_MASTER_GAME_SUCCESS:
        case ACTIONS_MASTER.GET_MASTER_TEAM_SUCCESS:    
            return {
                ...state,
                status: action.type,
                response: action.data,
                time: new Date()
            };
        case ACTIONS_MASTER.GET_YEAR_ERROR:
        case ACTIONS_MASTER.GET_MASTER_GAME_ERROR:
        case ACTIONS_MASTER.GET_MASTER_TEAM_ERROR:    
            return {
                ...state,
                status: action.type,
                message: action.err,
            };
        default:
            return state;
    }
};
